'use client';

import { mergeProps } from '@react-aria/utils';

import { useActionTrigger } from '@/hooks/useAction';
import { Button, ButtonProps } from '@/ui/Button';
import { cx } from '@/ui/cva';

export function SubscribeButton({ className, ...props }: ButtonProps) {
    const open = useActionTrigger('open_subscribe');

    return (
        <Button
            variant="outlined"
            color="gradient"
            className={cx('py-xs font-semibold', className)}
            {...mergeProps(props, {
                onClick: () => open(),
            })}
        />
    );
}
